const DRIVE_FILE_PATH = /^\/file(\/u\/\d+)?\/d\/[A-Za-z0-9_-]+(\/.*)?$/;
const DRIVE_ID = /^[A-Za-z0-9_-]+$/;

/** Why a link can't start a video, or null (empty is fine). Mirrors the backend DriveLinks, which has the last word. */
export const driveLinkError = (text) => {
    const value = String(text ?? '').trim();
    if (!value) return null;
    const notDrive = 'Only Google Drive links work here. For YouTube, use New video in Files with Track this work off, then Link video here.';
    let url;
    try {
        url = new URL(value);
    } catch (e) {
        return notDrive;
    }
    if (!['http:', 'https:'].includes(url.protocol) || url.hostname !== 'drive.google.com' || url.username) return notDrive;
    if (url.pathname.startsWith('/drive/') || url.pathname.startsWith('/folderview')) {
        return 'This is a folder. Open the video in Drive and copy its own link.';
    }
    if (DRIVE_FILE_PATH.test(url.pathname)) return null;
    return ['/open', '/uc'].includes(url.pathname) && DRIVE_ID.test(url.searchParams.get('id') || '') ? null : notDrive;
};

/** A link that can start a video, so a blank or other link doesn't count. */
export const isDriveLink = (text) => !!String(text ?? '').trim() && !driveLinkError(text);
